document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".countdown-banner").forEach(function (section) {

    var endString = section.getAttribute("data-end-datetime");
    if (!endString) return;

    // Handle date formatting using browser timezone
    var endDate = new Date(endString.trim().replace(/\s+/, "T"));

    if (isNaN(endDate.getTime())) {
      console.warn("Countdown: Invalid end date:", endString);
      return;
    }

    var daysEl = section.querySelector(".js-countdown-days");
    var hoursEl = section.querySelector(".js-countdown-hours");
    var minutesEl = section.querySelector(".js-countdown-minutes");
    var secondsEl = section.querySelector(".js-countdown-seconds");

    let timer = null;

    function updateCountdown() {
      var now = new Date();
      var diff = endDate - now;

      if (diff <= 0) {
        ["00", "00", "00", "00"].forEach((v, i) =>
          [daysEl, hoursEl, minutesEl, secondsEl][i].textContent = v
        );
        if (section.getAttribute("data-hide-when-expired") === "true") {
          section.style.display = "none";
        }
        if (timer) clearInterval(timer);
        return;
      }

      var t = Math.floor(diff / 1000);
      daysEl.textContent    = String(Math.floor(t / 86400)).padStart(2, "0");
      hoursEl.textContent   = String(Math.floor((t % 86400) / 3600)).padStart(2, "0");
      minutesEl.textContent = String(Math.floor((t % 3600) / 60)).padStart(2, "0");
      secondsEl.textContent = String(t % 60).padStart(2, "0");
    }

    updateCountdown();
    timer = setInterval(updateCountdown, 1000);
  });
});
